export default "__VITE_ASSET__D1AsvE$B__"